import React, { useState } from 'react'
import styled from 'styled-components'
import { useRouteMatch, Link } from 'react-router-dom'
import { ArrowDownIcon, Button, CalculateIcon, Flex,IconButton,Input,Text, VerifiedIcon} from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import { Box } from 'react-feather'

const OuterContainer = styled(Flex)`
  max-width: 310px;
`

const InputDiv = styled.div`
    background: ${({ theme }) => theme.isDark?'#c59226':'#aa8ce5'};
    padding: 1px;
    width: 100%;
    border-radius: 16px;
`
const CenterContainer = styled.div`
    height: 120px;
    padding: 24px;
    border-radius: 16px;
    background: ${({ theme }) => theme.isDark?'#2c2926':'#fff'};
    /* background: linear-gradient(139.73deg, rgb(229, 253, 255) 0%, rgb(243, 239, 255) 100%); */
`
const PriceShow = styled.div`
    max-width: 82%;
    margin-right: 8px;
    display: flex;
`

const RoiInputContainer = styled.div`
  padding: 2px 0;
  position: relative;
  & > input {
    padding-left: 28px;
    max-width: 70%;
  }
  &:before {
    position: absolute;
    content: '$';
    color: ${({ theme }) => theme.colors.textSubtle};
    left: 16px;
    top: 8px;
  }
`
const ExpectButton = styled(IconButton)`
  background-color: #f98c0800;
  box-shadow:none;
  :hover{
    background-color: #f98c0800 !important;
    border:0px solid !important;
  }
  :active{
    background-color: #f98c0800 !important;
    border:0px solid !important;
  }
  :focus:not(:active){
    box-shadow:none;
  }
`

const Icon = styled.svg`
  fill: ${({ theme }) => theme.colors.textSubtle};
  margin-left: 10px;
  cursor: pointer;
`
const RoiDollarAmounts = styled(Text)<{ fadeOut: boolean }>`
  max-width:100%;
  position: relative;
  overflow-x: auto;
  &::-webkit-scrollbar {
    height: 0px;
  }

  ${({ fadeOut, theme }) =>
    fadeOut &&
    `
      &:after {
        background: linear-gradient(
          to right,
          ${theme.colors.background}00,
          ${theme.colors.background}E6
        );
        content: '';
        height: 100%;
        pointer-events: none;
        position: absolute;
        right: 0;
        top: 0;
        width: 40px;
      }
  `}
`
const RoiDisplayContainer = styled(Flex)`
  max-width: 90%;
  margin-right: 20px;
`
const EarningsContainer = styled(Flex)`
  max-width: 82%;
  display: inline-flex;
  margin-right: 8px;
`


export interface ExpectedProfitProps {
  atta:{
     roiUSD: string
     roiTokens:number,
     roiPercentage:number
  }
  onState?: () => void
  isOpen?: boolean
  expectedRoi:string
  handleExpectedRoiChange:(e:string) => void
  earningTokenSymbol:string,
  harvestTokenSymbol?:string
}
const ExpectedProfit:React.FC<ExpectedProfitProps> = ({
  harvestTokenSymbol,
  atta,
  isOpen,
  onState,
  expectedRoi,
  handleExpectedRoiChange,
  earningTokenSymbol
  }) => {
  const TranslateString = useI18n()
  const ENARING = 100000000000;
  const ENARPRCENT = 100000000000000000000000;
  return (
      <OuterContainer>
        <InputDiv>
         <CenterContainer>
              <Text bold small >{TranslateString(703,'ROI AT CURRENT RATES')}</Text>

              <Flex justifyContent='space-between'>
             
                     <PriceShow>
                         {
                             isOpen?(
                                <><RoiInputContainer>
                                  <Input
                                      // ref={inputRef}
                                      type="text"
                                      inputMode="decimal"
                                      pattern="^[0-9]+[.,]?[0-9]*$"
                                      scale="sm"
                                      value={expectedRoi}
                                      placeholder="0.0"
                                      onChange={(e)=>{handleExpectedRoiChange(e.target.value)}}
                                   />
                             </RoiInputContainer>
                           </>): 
                             (<>
                              <Text bold fontSize="24px">$</Text>
                              <RoiDisplayContainer>
                                  <RoiDollarAmounts fontSize="24px" bold fadeOut={parseFloat(expectedRoi) > ENARING}>
                                    {parseFloat(expectedRoi).toLocaleString('en',{minimumFractionDigits: parseFloat(expectedRoi) > 100000 ? 0 : 2,maximumFractionDigits: parseFloat(expectedRoi) > 100000 ? 0 : 2})}
                                  </RoiDollarAmounts> 
                              </RoiDisplayContainer>
                           
                              {/* <Text bold fontSize="24px">
                                {parseFloat(expectedRoi).toLocaleString('en',{minimumFractionDigits: parseFloat(expectedRoi) > 100000 ? 0 : 2,maximumFractionDigits: parseFloat(expectedRoi) > 100000 ? 0 : 2})}
                                </Text> */}
                             </>)
                            
                         }
                         
                       
                     </PriceShow>
       
                     <ExpectButton size="sm" onClick={()=>onState()}>
                       {
                         isOpen?
                         <Icon xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 512 512" width="20px"><g clipRule="evenodd" fillRule="evenodd"><ellipse cx="256" cy="256" fill="#46cc6b" rx="240" ry="240" transform="matrix(.707 -.707 .707 .707 -106.039 256)"/><path d="m492.545 296.714c-17.077 99.92-95.914 178.753-195.831 195.831l-129.201-129.201c-30.917-25.515-50.622-64.128-50.622-107.344 0-76.829 62.28-139.109 139.109-139.109 43.216 0 81.829 19.706 107.344 50.622z" fill="#179c5f"/><path d="m190.886 264.26 39.618 36.382c5.779 5.32 14.724 5.037 20.159-.567l70.679-67.671c5.749-5.528 5.923-14.674.393-20.426-5.53-5.743-14.671-5.923-20.42-.395l-61.222 58.617-29.635-27.213c-5.871-5.402-15.018-5.023-20.423.854-5.404 5.871-5.023 15.012.851 20.419zm65.114-147.369c76.829 0 139.109 62.28 139.109 139.109s-62.28 139.109-139.109 139.109-139.109-62.28-139.109-139.109 62.28-139.109 139.109-139.109z" fill="#fff"/></g></Icon>
                         : <Icon xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 512 511" width="20px"><path d="m362.667969 512.484375h-298.667969c-35.285156 0-64-28.714844-64-64v-298.667969c0-35.285156 28.714844-64 64-64h170.667969c11.796875 0 21.332031 9.558594 21.332031 21.335938 0 11.773437-9.535156 21.332031-21.332031 21.332031h-170.667969c-11.777344 0-21.332031 9.578125-21.332031 21.332031v298.667969c0 11.753906 9.554687 21.332031 21.332031 21.332031h298.667969c11.773437 0 21.332031-9.578125 21.332031-21.332031v-170.667969c0-11.773437 9.535156-21.332031 21.332031-21.332031s21.335938 9.558594 21.335938 21.332031v170.667969c0 35.285156-28.714844 64-64 64zm0 0" fill="#607d8b"/><g fill="#42a5f5"><path d="m368.8125 68.261719-168.792969 168.789062c-1.492187 1.492188-2.496093 3.390625-2.921875 5.4375l-15.082031 75.4375c-.703125 3.496094.40625 7.101563 2.921875 9.640625 2.027344 2.027344 4.757812 3.113282 7.554688 3.113282.679687 0 1.386718-.0625 2.089843-.210938l75.414063-15.082031c2.089844-.429688 3.988281-1.429688 5.460937-2.925781l168.789063-168.789063zm0 0"/><path d="m496.382812 16.101562c-20.796874-20.800781-54.632812-20.800781-75.414062 0l-29.523438 29.523438 75.414063 75.414062 29.523437-29.527343c10.070313-10.046875 15.617188-23.445313 15.617188-37.695313s-5.546875-27.648437-15.617188-37.714844zm0 0"/></g></Icon> 
                       }
                    </ExpectButton>
              </Flex>
              <Text bold small >
              ~ {atta.roiTokens} {harvestTokenSymbol} 
              {/* EBEN */}
                 <EarningsContainer>
                      <RoiDollarAmounts fontSize="14px" bold fadeOut={atta.roiPercentage > ENARPRCENT}>
                        &nbsp;({atta.roiPercentage.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%)                                  
                      </RoiDollarAmounts> 
                 </EarningsContainer>
              
              </Text>
             
            
              
         </CenterContainer>
        </InputDiv>
      </OuterContainer>

  )
}

export default ExpectedProfit
